<template>
    <div>
        <slot v-bind:cart="cart"
              v-bind:delete-item="deleteItem"></slot>
    </div>
</template>

<script>
export default {
    name: "vcs-new-cart",
    data: function () {
        return {
            cart: null,
            items: [],
            interval: null,
            ping: false,
        };
    },
    methods: {
        deleteItem: function (item) {
            // console.log(item);
            Vue.axios.get('/api/cart/delete/' + item.uuid)
                .then((response) => {
                    this.cart = response.data.cart;
                })
        },
        update: function () {
            Vue.axios.get('/api/cart/get')
                .then((response) => {
                    this.cart = response.data.cart;
                    this.items = response.data.cart.items;
                });
        },
        pingNow: function () {
            this.ping = true;
            setTimeout(() => {
                this.ping = false;
            }, 2000);
        },
    },
    mounted: function () {
        this.update();
        // this.interval = setInterval(this.update, 15000);
    },
}
</script>
<style scoped>

</style>
